import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LeadingIcon from '../../assets/SVGs/LeadingIcon.svg';
import sideArrow from '../../assets/SVGs/SideArrow.svg';
import Selected from '../../assets/SVGs/Selected.svg';
import More from '../../assets/SVGs/More.svg';
import deleteIcon from '../../assets/SVGs/deleteIcon.svg';
import editIcon from '../../assets/SVGs/editIcon.svg';
import trailingIcon from '../../assets/SVGs/trailingIcon.svg';
import setDefault from '../../assets/SVGs/setDefault.svg';
import closeIcon from '../../assets/SVGs/closeIcon.svg';
import homeBlueIcon from '../../assets/SVGs/homeBlueIcon.svg';
import CloseIcon from '@mui/icons-material/Close';
import { Autocomplete, Chip, TextField } from '@mui/material';

import { Box, IconButton } from '@material-ui/core';
import {
	openHierarchy,
	deleteSavedHierarchy,
	setSelectedHierarchy,
	saveHierarchyFilter,
	setHierarchyFilterRhId,
	setEditFlow,
	setEditHierarchy,
	clearSearchedHierarchy,
	updateSavedHierarchy,
	editSelectedHierarchy,
	clickApplyButton,
} from '../../redux/actions/fullCompanyViewAction';
import { setSelectedUPC } from '../../redux/actions/salesActions';
import { useDispatch, useSelector } from 'react-redux';
import { UserPortalContext } from '../../context/appcontext';
import SearchHierarchy from './SearchHierarchy';
import { colors } from '../../theme/color-palette';
import './style.css';
import SnackBarWrapper from '../SnackBarWrapper/SnackBarWrapper';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { BOGLE_REGULAR } from '../../constants/constant';
import SearchIcon from '@mui/icons-material/Search';
import WarningDialog from './WarningDialog';

const {
	PURPLE_GRAY,
	WHITE,
	GREY,
	LIGHT_GRAY_SHADE,
	LIGHT_GRAY_SHADE_1,
	TOGGLE_ACTIVE,
	PURPLE_ACTIVE,
	PURPLE_HOVER,
	LIST_CLR,
} = colors;

const useStyles = makeStyles(() => ({
	hierarchyFilterContainer: {
		textAlign: 'center',
		display: 'flex',
		cursor: 'pointer',
		alignContent: 'center',
		flexWrap: 'wrap',
		alignItems: 'center',
		height: '100%',
		'@media (max-width: 1300px)': {
			width: '100% !important',
		},
	},
	offFocus: {
		border: `1px solid ${PURPLE_GRAY}`,
		borderRadius: '4px',
	},
	onFocus: {
		border: `1px solid ${PURPLE_ACTIVE}`,
		backgroundColor: TOGGLE_ACTIVE,
		color: PURPLE_ACTIVE,
		borderRadius: '4px',
	},
	hierarchyFilter: {
		height: 'auto',
		width: '360px',
		backgroundColor: WHITE,
		zIndex: 1,
		position: 'absolute',
		marginTop: '8px',
		boxShadow: `0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)`,
		borderRadius: '4px',
	},
	searchContainer: {
		display: 'flex',
		padding: '12px 8px 12px 16px',
		alignItems: 'center',
		borderBottom: `1px solid ${PURPLE_GRAY}`,
	},
	savedHierachyContainer: {
		display: 'block',
		height: '208px',
		marginTop: '8px',
		marginBottom: '8px',
		overflowY: 'scroll',
	},
	CustomHierarchyContainer: {
		display: 'block',
		height: '26px',
		borderTop: `1px solid ${PURPLE_GRAY}`,
		padding: '12px 16px',
		'&:hover': {
			background: LIGHT_GRAY_SHADE,
		},
		cursor: 'pointer',
	},
	hoverElement: {
		background: LIGHT_GRAY_SHADE,
		cursor: 'pointer',
		borderRadius: '6px',
	},
	hoverClasses: {
		'&:hover': {
			background: LIGHT_GRAY_SHADE,
			cursor: 'pointer',
		},
	},
	hoverMoreIcon: {
		'&:hover': {
			background: `${TOGGLE_ACTIVE} !important`,
		},
	},
	customHoverClasses: {
		background: LIGHT_GRAY_SHADE,
		cursor: 'pointer',
		height: '26px',
	},
	hierarchyOptions: {
		width: '160px',
		height: '136px',
		backgroundColor: WHITE,
		boxShadow: `0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)`,
		borderRadius: '4px',
		zIndex: 2,
		position: 'absolute',
		top: '90px',
		marginLeft: '320px',
		marginTop: '40px',
		padding: '3px 0px 0px 0px',
		fontSize: '14px',
	},
	menuList: {
		height: '24px',
		padding: '10px 16px',
		display: 'flex',
		'&:hover': {
			background: LIGHT_GRAY_SHADE,
			cursor: 'pointer',
		},
	},
	defaultContainer: {
		border: `1px solid ${PURPLE_GRAY}`,
		borderRadius: '39px',
		fontSize: '11px',
		textAlign: 'center',
		backgroundColor: LIGHT_GRAY_SHADE_1,
		color: GREY,
		marginTop: '2px',
		height: '22px',
	},
	autocompleteStyles: {
		width: '100%',
		minWidth: '50px',
		position: 'relative',
		'& .MuiAutocomplete-endAdornment': {
			top: '0px !important',
			right: '-50px !important',
		},
		'& .MuiAutocomplete-inputRoot': {
			paddingRight: '0px !important',
		},
		'& .MuiAutocomplete-popper': {
			zIndex: 9,
		},
		'& .MuiAutocomplete-clearIndicator': {
			visibility: 'visible !important',
		},
		'& .MuiAutocomplete-root:hover .MuiAutocomplete-clearIndicator': {
			visibility: 'visible !important',
		},
		'& .MuiChip-deleteIcon': {
			fontSize: 13,
		},
		'& .MuiChip-root': {
			color: GREY,
			borderRadius: '2px !important',
			fontFamily: `${BOGLE_REGULAR} !important`,
			height: '26px !important',
			background: `${TOGGLE_ACTIVE} !important`,
			'& .MuiChip-label': {
				color: `${LIST_CLR} !important`,
				fontSize: '14px !important',
				padding: '3px 10px 3px 6px !important',
				fontStyle: 'normal !important',
				fontWeight: 400,
				textTransform: 'lowercase',
			},
			'& .MuiSvgIcon-root': {
				fontSize: 20,
				width: 20,
				height: 20,
				color: GREY,
			},
			'& .MuiChip-label:first-line': {
				textTransform: 'capitalize !important',
			},
		},
		'& .MuiAutocomplete-input': {
			width: 'auto',
		},
	},
	autocompleteWrapper: {
		display: 'flex',
		columnGap: '5px',
		flex: 1,
		alignItems: 'start',
	},
	searchIconWrapper: {
		display: 'flex !important',
		'& .MuiSvgIcon-root': {
			fontSize: '20px !important',
		},
	},
	iconsize: {
		fontSize: '20px !important',
	},
	searchInputStyles: {
		'& .MuiInputBase-input': {
			fontFamily: BOGLE_REGULAR,
			fontSize: '14px',
			paddingTop: '6px !important',
			width: 'auto',
		},
	},
}));

const HierarchyFilter = () => {
	const [clickedHierarchyMoreOptions, setClickedHierarchyMoreOptions] =
		useState('');

	const [hierarchyFilter, setHierarchyFilter] = useState(false);
	const [hierarchyOptions, setHierarchyOptions] = useState(false);
	const [showWarning, setWarning] = useState(false);
	const [isSnackBarOpen, setIsSnackBarOpen] = useState(true);
	const [isDefaultSnackBarOpen, setIsDefaultSnackBarOpen] = useState(true);
	const [isApplyBtnClick, setIsApplyBtnClick] = useState(false);
	const [hierarchyFilterList, setHierarchyFilterList] = useState(false);
	const [purpleBackground, setPurpleBackground] = useState(false);
	const [isSearchEditMode, setIsSearchEditMode] = useState(false);
	const [toBeDeletedHierarchy, setToBeDeletedHierarchy] = useState({});

	const hierarchyFilterRef = useRef();
	const portalUserContext = React.useContext(UserPortalContext);
	const classes = useStyles();
	const dispatch = useDispatch();

	const hierarchy = useSelector(
		(state) => state?.fullCompanyViewReducer?.hierarchy
	);

	const savedHierarchy = useSelector(
		(state) => state?.fullCompanyViewReducer?.savedHierarchy
	);
	const selectedHierarchy = useSelector(
		(state) => state?.fullCompanyViewReducer?.selectedHierarchy
	);
	const hierarchyArr = useSelector(
		(state) => state?.fullCompanyViewReducer?.hierarchy
	);
	const deleteSavedHierarchyErrorCode = useSelector(
		(state) => state?.fullCompanyViewReducer?.deleteSavedHierarchyErrorCode
	);

	const updateSavedHierarchyErrorCode = useSelector(
		(state) => state?.fullCompanyViewReducer?.updateSavedHierarchyErrorCode
	);

	const updateSavedHierarchyDefaultValue = useSelector(
		(state) => state?.fullCompanyViewReducer?.updateSavedHierarchyDefaultValue
	);

	const savedSearchedHierarchy = useSelector(
		(state) => state.fullCompanyViewReducer?.searchedHierarchy
	);

	const { selectedUPC } = useSelector((state) => state.salesReducer);

	useEffect(() => {
		const purpleBkgrnd =
			selectedUPC?.length ||
			selectedHierarchy?.name === 'All Departments and Categories'
				? false
				: true;
		setPurpleBackground(purpleBkgrnd);
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	});

	const closeUserSelectedHierachy = (e) => {
		e.stopPropagation();
		let selectedHierarchyRhid = '';
		hierarchyArr?.forEach((hierarchy) => {
			selectedHierarchyRhid += hierarchy.nestedId + ',';
		});
		dispatch(
			setSelectedHierarchy({
				name: 'All Departments and Categories',
				hierarchyFilterRhId: selectedHierarchyRhid?.slice(0, -1),
			})
		);
		dispatch(clearSearchedHierarchy([]));
		setHierarchyFilter(false);
	};

	const openHierarchyFilter = () => {
		setHierarchyFilter(!hierarchyFilter);
		setWarning(false);
		setHierarchyOptions(false);
		setHierarchyFilterList(true);
		setIsApplyBtnClick(true);
		dispatch(clickApplyButton(true));
	};

	const setUserSelectedHierarchy = (hierarchy) => {
		setHierarchyFilter(false);
		dispatch(setSelectedUPC([]));
		let selectedHierarchyRhid = '';
		hierarchy?.rhIds?.forEach((rhId) => {
			selectedHierarchyRhid += rhId + ',';
		});
		dispatch(
			setSelectedHierarchy({
				name: hierarchy?.name,
				hierarchyFilterRhId: selectedHierarchyRhid?.slice(0, -1),
			})
		);
	};

	const handleClickOutside = (e) => {
		const className = e.target.getAttribute('class');
		if (
			!hierarchyFilterRef?.current.contains(e.target) &&
			!className?.match(/autoCompleteList/) &&
			!className?.match(/MuiAutocomplete-option/) &&
			!className?.match(/MuiListSubheader-sticky/) &&
			!className?.match(/MuiDialog-paper/) &&
			!className?.match(/muiDialogTitle/) &&
			!className?.match(/MuiDialogActions-root/) &&
			!className?.match(/MuiButtonBase-root/)
		) {
			setHierarchyFilter(false);
			// dispatch(clickApplyButton(false));
		}
	};

	const generateIds = (index = 0) => {
		return 'savedHierachy-' + index;
	};

	const handleCustomClick = () => {
		dispatch(openHierarchy(true));
	};

	const openHierarchyOptions = (hierarchy) => {
		setClickedHierarchyMoreOptions(hierarchy?.name);
		setHierarchyOptions(true);
	};

	const deleteSelectedHierarchy = (hierarchy) => {
		if (hierarchy?.name === selectedHierarchy?.name || hierarchy?.isDefault) {
			let selectedHierarchyRhid = '';
			hierarchyArr?.forEach((hierarchy) => {
				selectedHierarchyRhid += hierarchy.nestedId + ',';
			});
			dispatch(
				setSelectedHierarchy({
					name: 'All Departments and Categories',
					hierarchyFilterRhId: selectedHierarchyRhid?.slice(0, -1),
				})
			);
			dispatch(saveHierarchyFilter(selectedHierarchyRhid?.slice(0, -1)));
		}
		dispatch(
			deleteSavedHierarchy({
				portalUserContext,
				request: hierarchy,
			})
		);
		setWarning(false);
		setHierarchyOptions(false);
		setHierarchyFilter(false);
		setIsSnackBarOpen(true);
	};

	const editHierachy = (hierarchy) => {
		if (hierarchy.name === selectedHierarchy.name) {
			dispatch(editSelectedHierarchy(true));
		}
		dispatch(openHierarchy(true));
		dispatch(setEditFlow(true));
		let selectedHierarchyRhid = '';
		hierarchy?.rhIds?.forEach((rhId) => {
			selectedHierarchyRhid += rhId + ',';
		});
		dispatch(setHierarchyFilterRhId(selectedHierarchyRhid.slice(0, -1)));
		dispatch(setEditHierarchy(hierarchy));
		setHierarchyOptions(false);
	};

	const changeDefaultHierarchy = (hierarchy) => {
		const updatedHierarchy = {
			...hierarchy,
			isDefault: !hierarchy.isDefault,
		};

		const payload = {
			insightPreferences: [updatedHierarchy],
		};
		dispatch(
			updateSavedHierarchy({
				portalUserContext,
				request: payload,
			})
		);
		setHierarchyOptions(false);
		setIsDefaultSnackBarOpen(true);
	};

	const handleClose = () => {
		setWarning(close);
		setToBeDeletedHierarchy({});
	};

	const cancleHeirarchyDropdown = () => {
		setHierarchyFilter(false);
		setHierarchyFilterList(true);
	};

	const handleSnackBarClose = () => {
		setIsSnackBarOpen(false);
	};

	const handleDefaultSnackBarClose = () => {
		setIsDefaultSnackBarOpen(false);
	};

	const action = (
		<React.Fragment>
			<IconButton
				size="small"
				aria-label="close"
				color="inherit"
				fontSize="14px"
				onClick={handleSnackBarClose}>
				<CloseIcon fontSize="small" />
			</IconButton>
		</React.Fragment>
	);

	const defaultAction = (
		<React.Fragment>
			<IconButton
				size="small"
				aria-label="close"
				color="inherit"
				fontSize="14px"
				onClick={handleDefaultSnackBarClose}>
				<CloseIcon fontSize="small" />
			</IconButton>
		</React.Fragment>
	);

	const handleOnClick = () => {
		setIsSearchEditMode(true);
	};

	const TAG_LIMIT = 2;

	const handleDeleteHierarchyClick = (hierarchy) => {
		setToBeDeletedHierarchy(hierarchy);
		setWarning(true);
	};

	return (
		<Box
			ref={hierarchyFilterRef}
			style={{
				height: '30px',
				minWidth: '242px !important',
				boxSizing: 'border-box !important',
			}}>
			<Box
				id="hierarchy-filter"
				data-test={'hierarchy-filter'}
				sx={{
					backgroundColor: hierarchyFilter ? TOGGLE_ACTIVE : '',
					color: hierarchyFilter ? '#3C228A' : '',
					'&:hover': {
						background: !purpleBackground ? LIGHT_GRAY_SHADE : TOGGLE_ACTIVE,
					},
				}}
				tabIndex={0}
				className={`${classes.hierarchyFilterContainer}
					${purpleBackground ? classes.onFocus : classes.offFocus}`}
				onClick={openHierarchyFilter}>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						height: '100%',
						flex: 1,
						'&:hover': {
							background: purpleBackground ? PURPLE_HOVER : 'transparent',
						},
					}}>
					<Box
						style={{
							marginLeft: '8px',
							marginRight: '8px',
							marginTop: '2px',
						}}>
						{purpleBackground ? (
							<img src={homeBlueIcon} alt="leading"></img>
						) : (
							<img src={LeadingIcon} alt="leading"></img>
						)}
					</Box>
					<Box
						style={{
							fontSize: '14px',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
							maxWidth: '200px',
							overflow: 'hidden',
							paddingRight: '8px',
						}}>
						{selectedHierarchy?.name}
					</Box>
				</Box>
				{selectedHierarchy?.name !== 'All Departments and Categories' ? (
					<Box
						sx={{
							borderLeft: `1px solid ${
								purpleBackground ? PURPLE_ACTIVE : PURPLE_GRAY
							}`,
							minWidth: 32,
							display: 'flex',
							height: '100%',
							textAlign: 'center',
							justifyContent: 'center',
						}}
						onClick={(e) => closeUserSelectedHierachy(e)}>
						<img
							data-test-id="set-to-allDepartment"
							src={closeIcon}
							alt="close-icon"
							style={{ width: '12px', padding: '0px 6px' }}></img>
					</Box>
				) : (
					<Box
						style={{
							display: 'flex',
							padding: '6px 6px 6px 3px ',
							alignItems: 'center',
						}}>
						<ArrowDropDownIcon
							sx={{
								padding: 0,
							}}
						/>
					</Box>
				)}
			</Box>
			{hierarchyFilter && (
				<Box className={classes.hierarchyFilter}>
					<Box
						className={classes.searchContainer}
						data-test-id="search-container">
						{!isSearchEditMode && (
							<Box className={classes.autocompleteWrapper}>
								<Box
									className={classes.searchIconWrapper}
									sx={{
										cursor:
											savedSearchedHierarchy?.length > 0
												? 'pointer'
												: 'initial',
										margin:
											savedSearchedHierarchy?.length > 0
												? '6px 5px 0px 0px'
												: '4px 5px 0px 0px',
									}}>
									<SearchIcon className={classes.iconsize} />
								</Box>
								<Autocomplete
									clearIcon={false}
									className={classes.autocompleteStyles}
									options={[]}
									freeSolo
									multiple
									readOnly
									limitTags={TAG_LIMIT}
									value={savedSearchedHierarchy}
									sx={{
										width: '100%',
										'& MuiAutocomplete-root': {
											width: '100%',
										},
										'& .MuiAutocomplete-tag': {
											maxWidth: '96px',
										},
									}}
									renderTags={(tagValue, getTagProps) => {
										return tagValue?.map((option, index) => {
											return (
												<Chip
													label={`${option.id} ${option.name}`}
													key={`${option.id}-index`}
													{...getTagProps({ index })}
													onDelete={() => {}}
													deleteIcon={<CloseIcon />}
												/>
											);
										});
									}}
									renderInput={(params) => {
										return (
											<TextField
												{...params}
												className={classes.searchInputStyles}
												fullWidth
												size="small"
												variant="standard"
												onFocus={handleOnClick}
												rows={1}
												InputProps={{
													...params.InputProps,
													disableUnderline: true,
													readOnly: true,
												}}
												placeholder={
													savedSearchedHierarchy?.length ? '' : 'Search'
												}
											/>
										);
									}}
								/>
							</Box>
						)}
						{isSearchEditMode && (
							<SearchHierarchy
								hierarchy={hierarchy}
								cancleHeirarchyDropdown={cancleHeirarchyDropdown}
								isApplyBtnClick={isApplyBtnClick}
								setIsApplyBtnClick={setIsApplyBtnClick}
								setHierarchyFilterList={setHierarchyFilterList}
								setIsSearchEditMode={setIsSearchEditMode}
							/>
						)}
					</Box>
					{hierarchyFilterList && (
						<>
							<Box className={classes.savedHierachyContainer}>
								<Box
									style={{
										height: '32px',
										padding: '8px 16px',
										fontSize: '12px',
									}}>
									<Box style={{ marginTop: '8px', color: '#6D6E71' }}>
										My Saved Hierarchies ({savedHierarchy?.length})
									</Box>
								</Box>
								<Box
									style={{
										padding: '8px 0px',
										marginTop: '-10px',
									}}>
									{savedHierarchy?.map((hierarchy, index) => {
										return (
											<Box
												style={{
													display: 'flex',
													height: '36px',
													padding: '0px 16px',
													alignItems: 'center',
												}}
												className={classes.hoverClasses}
												onMouseLeave={() => {
													setHierarchyOptions(false);
												}}
												id={generateIds(index)}
												key={generateIds(index)}>
												<Box style={{ minWidth: '20px', marginTop: '5px' }}>
													{selectedHierarchy?.name === hierarchy?.name && (
														<img src={Selected} alt="selected"></img>
													)}
												</Box>
												<Box
													style={{
														fontSize: '14px',
														marginLeft: '10px',
														minWidth: '206px',
														maxWidth: '206px',
														height: '22px',
														marginTop: '6px',
														textOverflow: 'ellipsis',
														overflow: 'hidden',
														whiteSpace: 'nowrap',
													}}
													onClick={() => setUserSelectedHierarchy(hierarchy)}>
													{hierarchy.name}
												</Box>
												<Box
													style={{
														fontSize: '14px',
														minWidth: '52px',
													}}>
													{hierarchy.isDefault && (
														<Box className={classes.defaultContainer}>
															<Box
																style={{
																	textAlign: 'center',
																	marginTop: '3px',
																}}>
																Default
															</Box>
														</Box>
													)}
												</Box>
												<Box
													data-test-id={`more-${hierarchy.name}`}
													style={{
														fontSize: '14px',
														marginLeft: '10px',
													}}
													onClick={() => openHierarchyOptions(hierarchy)}>
													<Box
														className={classes.hoverMoreIcon}
														style={{
															height: '17px',
															borderRadius: '100%',
															padding: '2px 3px',
														}}>
														<img src={More} alt="more"></img>
													</Box>
												</Box>
												{hierarchyOptions &&
												clickedHierarchyMoreOptions === hierarchy.name ? (
													<Box className={classes.hierarchyOptions}>
														<Box
															className={classes.menuList}
															onClick={() => changeDefaultHierarchy(hierarchy)}>
															{hierarchy?.isDefault ? (
																<>
																	<Box style={{ marginRight: '8px' }}>
																		<img
																			src={trailingIcon}
																			alt="Trailing"></img>
																	</Box>
																	<Box>Remove default</Box>
																</>
															) : (
																<>
																	<Box
																		style={{
																			marginRight: '16px',
																			marginTop: '2px',
																		}}>
																		<img
																			src={setDefault}
																			alt="Set default"></img>
																	</Box>
																	<Box>Set as default</Box>
																</>
															)}
														</Box>
														<Box
															data-testid="editHierarchy"
															className={classes.menuList}
															onClick={() => editHierachy(hierarchy)}>
															<Box style={{ marginRight: '10px' }}>
																<img src={editIcon} alt="Edit"></img>
															</Box>
															<Box>Edit</Box>
														</Box>
														<Box
															data-testid="deleteHierarchy"
															className={classes.menuList}
															onClick={() =>
																handleDeleteHierarchyClick(hierarchy)
															}>
															<Box style={{ marginRight: '15px' }}>
																<img src={deleteIcon} alt="Delete"></img>
															</Box>
															<Box style={{ marginTop: '-1px' }}>Delete</Box>
														</Box>
													</Box>
												) : (
													''
												)}
											</Box>
										);
									})}
								</Box>
							</Box>
							<Box
								className={classes.CustomHierarchyContainer}
								id="customHierarchyFilter"
								data-test="customHierarchyFilter"
								onClick={handleCustomClick}>
								<Box style={{ display: 'flex' }}>
									<Box style={{ width: '320px', fontSize: '14px' }}>
										{' '}
										Custom
									</Box>
									<Box>
										<img src={sideArrow} alt="side-Arrow"></img>
									</Box>
								</Box>
							</Box>
						</>
					)}
				</Box>
			)}

			{showWarning && (
				<WarningDialog
					open={showWarning}
					handleClose={handleClose}
					handleDelete={deleteSelectedHierarchy}
					hierarchy={toBeDeletedHierarchy}
				/>
			)}
			{deleteSavedHierarchyErrorCode !== 0 && (
				<SnackBarWrapper
					variant={deleteSavedHierarchyErrorCode > 200 ? 'error' : 'success'}
					open={isSnackBarOpen}
					hideDuration={5000}
					message={
						deleteSavedHierarchyErrorCode > 200
							? `Can't delete hierarchy. Try again.`
							: 'Hierarchy deleted Successfully.'
					}
					action={action}
					onClose={handleSnackBarClose}
				/>
			)}
			{updateSavedHierarchyErrorCode !== 0 && (
				<SnackBarWrapper
					variant={'success'}
					open={isDefaultSnackBarOpen}
					hideDuration={5000}
					message={
						updateSavedHierarchyDefaultValue
							? `Default Set Successfully.`
							: 'Default removed Successfully.'
					}
					action={defaultAction}
					onClose={handleDefaultSnackBarClose}
				/>
			)}
		</Box>
	);
};

export default HierarchyFilter;
